import React from "react";
import { Link, useMatch } from "react-router-dom";

import GoogleMap from "./Utils/GoogleMap";

import footerBg from "../assets/img/bg/footer-bg.png";
import logo from "../assets/img/logo/logo.png";

export default function Main() {
  const homeNavActive = useMatch("/");
  const aboutNavActive = useMatch("/about");
  const roomNavActive = useMatch("/rooms");
  const serviceDetailsNavActive = useMatch("/attractions");
  const galleryNavActive = useMatch("/gallery");
  const teamDetailsNavActive = useMatch("/team-details");
  const contactNavActive = useMatch("/contact");

  return (
    <>
      <footer className="footer-bg footer-p">
        <div
          className="footer-top  pt-4 pb-40"
          style={{
            background_color: "#644222",
            backgroundImage: `url(${footerBg})`,
          }}
        >
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-auto">
                <div className="f-widget-title mb-30" style={{width: "120px", height: "120px"}}>
                  {homeNavActive ? (
                    <img src={logo} alt="img" />
                  ) : (
                    <Link to="/">
                      <img src={logo} alt="img" />
                    </Link>
                  )}
                </div>
                <div className="f-contact">
                  <ul style={{ color: "hsl(47,99%,54%)", display: "flex", flexDirection: "column"}}>
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <i
                        className="icon fa-solid fa-phone"
                        style={{
                          backgroundColor: "hsl(136,61%,26%)",
                          color: "hsl(47,99%,54%)",
                        }}
                      ></i>
                      <span>+48 607 383 844</span>
                    </li>
                    <li style={{ display: "flex", alignItems: "center" }}>
                      <i
                        className="icon fa-solid fa-envelope"
                        style={{
                          backgroundColor: "hsl(136,61%,26%)",
                          color: "hsl(47,99%,54%)",
                        }}
                      ></i>
                      <span>
                        <span>slonecznepodgorze@gmail.com</span>
                      </span>
                    </li>
                    <li style={{ display: "flex", alignItems: "center" }}>
                      <i
                        className="icon fa-solid fa-location-dot"
                        style={{
                          backgroundColor: "hsl(136,61%,26%)",
                          color: "hsl(47,99%,54%)",
                        }}
                      ></i>
                      <span>Podgórze 55, 57-340 Duszniki-Zdrój</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-auto not-small-footer-display">
                <div className="footer-widget mb-30">
                  <div className="f-widget-title">
                    <h2>Linki</h2>
                  </div>
                  <div className="footer-link">
                    <ul>
                      <li>
                        {!homeNavActive && (
                          <Link to="/" style={{ whiteSpace: "nowrap" }}>
                            Strona główna
                          </Link>
                        )}
                      </li>
                      <li>
                        {!aboutNavActive && (
                          <Link to="/about" style={{ whiteSpace: "nowrap" }}>
                            O nas
                          </Link>
                        )}
                      </li>
                      <li>
                        {!roomNavActive && (
                          <Link to="/rooms" style={{ whiteSpace: "nowrap" }}>
                            Pokoje i serwis
                          </Link>
                        )}
                      </li>
                      <li>
                        {!serviceDetailsNavActive && (
                          <Link to="/attractions">Atrakcje</Link>
                        )}
                      </li>
                      <li>
                        {!galleryNavActive && (
                          <Link to="/gallery">Galeria</Link>
                        )}
                      </li>
                      <li>
                        {!teamDetailsNavActive && (
                          <Link to="/team-details">Zespół</Link>
                        )}
                      </li>
                      <li>
                        {!contactNavActive && (
                          <Link to="/contact"> Kontakt</Link>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                {!contactNavActive && (
                  <GoogleMap
                    style={{ width: "100%", height: "100%" }}
                  ></GoogleMap>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container">
            <div className="row py-2">
              <div className="col mr-auto align-items-center d-flex align-items-center">
                Słoneczne Podgórze
              </div>
              <div className="col-auto">
                <div className="footer-social">
                  <Link to="#">
                    <i
                      className="fab fa-facebook-f"
                      style={{ color: "hsl(136,61%,26%)" }}
                    ></i>
                  </Link>
                  <Link to="#">
                    <i
                      className="fab fa-youtube"
                      style={{ color: "hsl(136,61%,26%)" }}
                    ></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
